'use strict';

exports.__esModule = true;

var _INSURERS_SHORT_NAME_;

var TABLET_WIDTH = exports.TABLET_WIDTH = 768;
var MOBILE_LARGE_WIDTH = exports.MOBILE_LARGE_WIDTH = 425;
var MIN_LAPTOP_SMALL_WIDTH = exports.MIN_LAPTOP_SMALL_WIDTH = 769;
var MAX_LAPTOP_SMALL_WIDTH = exports.MAX_LAPTOP_SMALL_WIDTH = 972;
var MIN_LAPTOP_MEDIUM_WIDTH = exports.MIN_LAPTOP_MEDIUM_WIDTH = 973;
var MAX_LAPTOP_MEDIUM_WIDTH = exports.MAX_LAPTOP_MEDIUM_WIDTH = 1658;
var MOBILE_CALENDAR_DAYS = exports.MOBILE_CALENDAR_DAYS = 3;
var TABLET_CALENDAR_DAYS = exports.TABLET_CALENDAR_DAYS = 5;
var LAPTOP_CALENDAR_DAYS = exports.LAPTOP_CALENDAR_DAYS = 7;
var NEAREST_AVAILABILITY_END_DAYS = exports.NEAREST_AVAILABILITY_END_DAYS = 100;

var I_CANT_SEE_MY_LIST_ID = exports.I_CANT_SEE_MY_LIST_ID = -1;
var LONDON_CARE_HOSPITAL_LIST_ID = exports.LONDON_CARE_HOSPITAL_LIST_ID = 26;
var COUNTRY_WIDE_HOSPITAL_LIST_ID = exports.COUNTRY_WIDE_HOSPITAL_LIST_ID = 27;
var LOCAL_HOSPITAL_LIST_ID = exports.LOCAL_HOSPITAL_LIST_ID = 28;
var CONSULTANT_SELECT_HOSPITAL_LIST_ID = exports.CONSULTANT_SELECT_HOSPITAL_LIST_ID = 29;

var INSURERS_SHORT_NAME_DICTIONARY = exports.INSURERS_SHORT_NAME_DICTIONARY = (_INSURERS_SHORT_NAME_ = {}, _INSURERS_SHORT_NAME_[I_CANT_SEE_MY_LIST_ID] = '', _INSURERS_SHORT_NAME_[LONDON_CARE_HOSPITAL_LIST_ID] = 'LC', _INSURERS_SHORT_NAME_[COUNTRY_WIDE_HOSPITAL_LIST_ID] = 'CW', _INSURERS_SHORT_NAME_[LOCAL_HOSPITAL_LIST_ID] = 'L', _INSURERS_SHORT_NAME_[CONSULTANT_SELECT_HOSPITAL_LIST_ID] = 'CS', _INSURERS_SHORT_NAME_);


// WEBPACK FOOTER //
// ./components/specialist-page/lib/utils/constants.js